
let globalNavigate = null;

class navigationServices {
    setGlobalNavigate (navigate) {
    globalNavigate = navigate;
    };

    navigateTo (path) {
    if (globalNavigate) {
        globalNavigate(path);
    } else {
        console.error("Navigation function is not initialized yet.");
    }
    };
}

export default new navigationServices();